import { useEffect, useState } from "react";
import { DefaultLoadingManager } from "three";
import useSound from "use-sound";
import { Audio } from "./utils/assetManager";
import { AudioAsset } from "./store/AssetSlice";
import { useStore } from "./store/Store";
import { ACTION_TRIGGERS } from "./ActionTriggers";
import { suspend } from "suspend-react";

export const AudioComponent = (
  { audio }: { audio: Audio } = {
    audio: { loops: false, volume: 1, url: "", name: "" },
  }
) => {
  const [audioPlaying, setAudioPlaying] = useState(false);
  const triggerAction = useStore().triggerAction;
  const addAsset = useStore().addAsset;
  const loadingManager = DefaultLoadingManager;

  // This is done, because it ensures that the itemStart function is only called once
  suspend(async () => {
    loadingManager.itemStart(audio.url);
  }, [audio.url]);

  const [play, { stop, pause, sound }] = useSound(
    audio.url,
    {
      loop: audio.loops,
      volume: audio.volume,
      onload: () => {
        loadingManager.itemEnd(audio.url);
      },
      onloaderror: () => {
        loadingManager.itemEnd(audio.url);
        loadingManager.itemError(audio.url);
      },
      onend: () => {
        setAudioPlaying(false);
      },
    } // more options see: https://github.com/goldfire/howler.js#options
  );

  useEffect(() => {
    if (!sound) return;
    const fade = sound.fade.bind(sound);
    const audioAsset: AudioAsset = {
      play: (delay?: number) => {
        if (!audioPlaying) {
          setTimeout(() => {
            console.log("sound", sound.volume());
            setAudioPlaying(true);
            play();
          }, delay);
        }
      },
      stop,
      pause,
      fade,
      sound,
    };
    addAsset(audioAsset, audio.name);
    triggerAction(ACTION_TRIGGERS.SOUND_LOADED, audio.name);
  }, [
    sound,
    addAsset,
    play,
    stop,
    pause,
    audio.name,
    triggerAction,
    audioPlaying,
  ]);

  return <></>;
};
